import { SliceCaseReducers } from '@reduxjs/toolkit'
import { createOperationSlice, GenericOperationState } from '@repo/core'
import { ChangePasswordPayload, OtpRequiredResponse } from '@repo/user-types'

const initialState: GenericOperationState<OtpRequiredResponse | null> = {
  payload: null,
  meta: { fetchState: 'initial' },
  error: false,
}

export const { actions: changePasswordActions, reducer: changePasswordReducer } =
  createOperationSlice<
    OtpRequiredResponse | null,
    SliceCaseReducers<GenericOperationState<OtpRequiredResponse | null>>,
    ChangePasswordPayload
  >({
    name: '@users/security/changePassword',
    initialState,
    reducers: {},
  })
